'use client';

import { useEffect, useState } from 'react';
import { Analytics } from '@vercel/analytics/next';
import { SpeedInsights } from '@vercel/speed-insights/next';

import { appConfig } from '@/config/appConfig';

const ALLOWED_ANALYTICS_HOSTS = new Set([
  'wci.tech',
  'www.wci.tech',
  'uat.wci.tech',
  'qa.wci.tech',
]);

const isLocalOrPrivateHost = (hostname: string) => {
  return (
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname === '0.0.0.0' ||
    hostname.startsWith('192.168.') ||
    hostname.startsWith('10.') ||
    hostname.startsWith('172.')
  );
};

const canUseVercelMetrics = () => {
  if (typeof window === 'undefined') return false;

  const hostname = window.location.hostname;

  if (isLocalOrPrivateHost(hostname)) return false;

  if (!ALLOWED_ANALYTICS_HOSTS.has(hostname)) return false;

  return appConfig.integrations.vercelMetrics.enabled;
};

const AnalyticsMetrics = () => {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    if (!canUseVercelMetrics()) return;

    const timeoutId = globalThis.setTimeout(() => {
      setEnabled(true);
    }, 3000);

    return () => {
      globalThis.clearTimeout(timeoutId);
    };
  }, []);

  if (!enabled) return null;

  return (
    <>
      <Analytics debug={false} />
      <SpeedInsights debug={false} />
    </>
  );
};

export default AnalyticsMetrics;
